import { useMemo } from "react";

import { useDisplayLocale } from "~/common/functions/useDisplayLocale";

import { useCategoryListByType } from "~/features/admin/categories/hooks";
import { buildLineageEdges, buildLineageNodes } from "~/features/admin/categories/utils/transformers";
import { CategoryLineage } from "./CategoryLineage";

interface CategoryLineageTabProps {
  categoryType: "entity" | "relation";
  onSelect: (id: string) => void;
  /** Highlight the matching node when set (driven by `?selectedCategory=` URL param). */
  selectedCategoryId?: string | null;
}

/** Thin container for the entity/relation lineage (tree) tabs. */
export function CategoryLineageTab({ categoryType, onSelect, selectedCategoryId }: CategoryLineageTabProps) {
  const locale = useDisplayLocale();
  const { data } = useCategoryListByType(categoryType);

  const nodes = useMemo(() => buildLineageNodes(data.categories, locale), [data.categories, locale]);
  const edges = useMemo(() => buildLineageEdges(nodes), [nodes]);

  return <CategoryLineage nodes={nodes} edges={edges} onSelect={onSelect} selectedCategoryId={selectedCategoryId} />;
}
